//对象的快速复制  不存在的key不复制
const copyUtils = {
    objCoppy:function(obj1,obj2){
      Object.keys(obj2).forEach(key =>{
        obj2[key] = obj1[key]
      })
    },
    //对象深度拷贝
    objAllCopy:function(obj1){
      return JSON.parse(JSON.stringify(obj1));
    },
    //数组深度拷贝
    listAllCopy:function(list1){
      let list2 = [];
      list1.forEach(obj=>{
        list2.push(JSON.parse(JSON.stringify(obj)));
      });
      return list2;
    },
};

export default copyUtils;
